/**
 * The version this build is, in one place.
 *
 * Read by the release notes screen and -- less obviously -- by the translation
 * loader, which appends it to the bundle URL as a cache buster.
 *
 * THAT IS NOT DECORATION. assets/i18n/en.json is the one file Angular does not
 * fingerprint: its name is identical in every build. It was being uploaded with
 * a one-year immutable cache header, so browsers held the copy they first
 * fetched and every translation added afterwards rendered as a raw key --
 * RELEASE.TITLE, ISSUE.COL_STATUS -- on a screen whose JavaScript was current,
 * because the bundles ARE fingerprinted and had been replaced.
 *
 * The header is fixed, but a browser that already cached the file keeps it for
 * a year whatever the server now says, and there is no way to reach into it.
 * Versioning the URL sidesteps that entirely: ?v=7.0.1 is a different cache
 * entry, so a release can never serve last release's words.
 *
 * Keep this in step with package.json and with the newest entry in
 * components/release-notes.
 */
export const APP_VERSION = '7.0.1';
